import { render, staticRenderFns } from "./inspectionRecord.vue?vue&type=template&id=2859f6cf&"
import script from "./inspectionRecord.vue?vue&type=script&lang=js&"
export * from "./inspectionRecord.vue?vue&type=script&lang=js&"
import style0 from "./inspectionRecord.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports